<div class="container" fxFlex perfect-scrollbar>
  <div class="header thin-header mat-accent-bg p-12 p-sm-24" fxLayout="row" fxLayoutAlign="start start" fxLayout.gt-xs="row"
    fxLayoutAlign.gt-xs="row">

    <div fxFlex="" fxLayoutAlign="start center">

      <span class="logo-text h1">Case Transaction form</span>

    </div>
    <div fxFlex fxLayoutAlign="end center"></div>
  </div>

  <div class="content" [@.disabled]="true">
    <nav mat-tab-nav-bar>
      <a mat-tab-link (click)="selectedTab = 'receiveAmount'" [active]="selectedTab == 'receiveAmount'" style="padding: 0px;">Receive
        Amount </a>
      <a mat-tab-link (click)="selectedTab = 'spentAmount'" [active]="selectedTab == 'spentAmount'" style="padding: 0px;">Spent
        Amount </a>

    </nav>
    <br>
    <div class="p-12 tab-content" [class.show]="selectedTab == 'receiveAmount'">
      <app-receive-amount [caseData]="caseData" [dataSource]="receiveAmount" [getExistingDetails]="getExistingDetails"
        (existingPositiveDetails)="receiveDetails($event)"></app-receive-amount>
    </div>
    <div class="p-12 tab-content" [class.show]="selectedTab == 'spentAmount'">
      <app-spent-amount [caseData]="caseData" [dataSource]="spentAmount" [getExistingDetails]="getExistingDetails"
        (existingNegativeDetails)="spentDetails($event)"></app-spent-amount>
    </div>
  </div>
  <br>
  <button [class.loading]="getExistingDetails" mat-raised-button color="accent" class="pull-right" (click)="submitSevenOne()"
    style="margin: 25px;" [disabled]= "getExistingDetails">
    <div class="spinner"></div>
    <span class="label">Submit</span>
  </button>
</div>



// WEBPACK FOOTER //
// ./src/app/main/content/common/seven-one/seven-one-main/seven-one-main.component.html